<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title> Add Print Product </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="product.providerId"
                :items="print_providers"
                item-text="name"
                item-value="id"
                label="Provider"
                hide-details="auto"
                outlined
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col
              v-if="product.providerId == $enums.PROVIDER.FOUROVER"
              cols="12"
            >
              <v-autocomplete
                v-model="product.externalId"
                :items="four_over_products"
                item-text="description"
                item-value="externalId"
                label="4Over Product"
                hide-details="auto"
                outlined
                :rules="[$rules.required]"
              />
            </v-col>
            <template v-else-if="product.providerId">
              <v-col cols="12">
                <v-text-field
                  v-model="product.name"
                  label="Name"
                  outlined
                  hide-details="auto"
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="product.category"
                  label="Category"
                  outlined
                  hide-details="auto"
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="product.width"
                  label="Width"
                  outlined
                  :rules="[$rules.required]"
                  hide-details="auto"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="product.height"
                  label="Height"
                  outlined
                  :rules="[$rules.required]"
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="product.unitId"
                  :items="units"
                  item-text="name"
                  item-value="id"
                  label="Units"
                  outlined
                  :rules="[$rules.required]"
                  hide-details="auto"
                />
              </v-col>
              <v-col
                v-if="product.material"
                cols="12"
              >
                <v-select
                  v-model="product.material.id"
                  :items="print_materials"
                  item-text="display"
                  item-value="id"
                  label="Material"
                  hide-details="auto"
                  outlined
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="product.externalId"
                  label="External Id"
                  outlined
                  hide-details="auto"
                />
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <v-divider />
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Add
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import { orderBy } from 'lodash';
export default {
  name: 'AddPrintProduct',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      product: {}
    };
  },

  computed: {
    four_over_products() {
      return this.fourover_list.filter((x) => !x.relatedPrintProductId);
    },
    print_materials() {
      return orderBy(this.print_lookups?.materials, ['display'], ['asc']);
    },
    ...mapGetters({
      units: 'lookup/units',
      print_providers: 'lookup/print_providers',
      fourover_list: 'print/fourover_list',
      print_lookups: 'print/lookups'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.ADD_PRINT_PRODUCT_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.ADD_PRINT_PRODUCT_SHOW, () => {
      this.product = { material: {} };
      this.drawer = true;
    });
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true
      ;(this.product.providerId === this.$enums.PROVIDER.FOUROVER
        ? this.$store.dispatch('print/addFourOverProduct', this.product.externalId)
        : this.$store.dispatch('print/addProduct', this.product)
      )
        .then(() => {
          this.$root.$snackbarSuccess('Print Product added');
          this.$emit('save');
          this.drawer = false;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
